import {
    Feed,
    InfluencerPage,
  } from '.';
  import {
    StreetSnap,
  } from '../streetSnap';
  import {
    ProductDetail,
  } from '../product';
import {
  HomeLayout
} from '../layout';
  export default {
    path: '/',
    name: 'Homepage',
    component: HomeLayout,
    childRoutes: [
      { path: '', name: 'Feed', component: Feed, isIndex: true },
      { path: 'influencer/:influencer_id', name: 'Influencer', component: InfluencerPage },
      { path: 'similar_influencer/:influencer_id', name: 'SimilarInfluencer', component: InfluencerPage },
      { path: 'product/detail/:shopItemId/group/:shopItemGroupId', name: 'ProductDetail', component: ProductDetail },
      { path: 'streetsnap/:streetSnapId', name: 'StreetSnap', component: StreetSnap}
    //   { path: 'counter', name: 'Counter page', component: CounterPage },
    //   { path: 'reddit', name: 'Reddit list page', component: RedditListPage },
    ],
  };
  


// WEBPACK FOOTER //
// ./src/features/homepage/route.js